// guards/client-login-redirect.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NavigationStateService } from '../../../../sales-client/application/uses-cases';

@Injectable({
  providedIn: 'root'
})
export class ClientLoginRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private navigationState: NavigationStateService
  ) { }

  canActivate(): boolean {
    if (this.navigationState.getFromButtonClick()) {
      return true;
    }

    this.router.navigate(['/salesclient']);
    return false;
  }
}